import { Injectable } from "@angular/core";
import { getContractualMonth } from "@shared/functions/date.functions";

@Injectable({
  providedIn: "root",
})
export class ProjValuesService {
  getProjValues(
    type: string,
    projDefault: number
  ): {
    startMonth: string;
    startMonthMinus1: string;
    startMonthMinus2: string;
    projValues: number[];
  } {
    switch (type) {
      case "oct-nov":
        return {
          startMonth: "DEC",
          startMonthMinus1: "NOV",
          startMonthMinus2: "OCT",
          projValues: [3600, 5040, 5580, 5700, 5580, 5700, 6900, 6900, 7800, 5040, 0, 0],
        };
      case "aug-sep":
        return {
          startMonth: "OCT",
          startMonthMinus1: "SEP",
          startMonthMinus2: "AUG",
          projValues: [2400, 5700, 7800, 5700, 5400, 5700, 5400, 5700, 7800, 5700, 0, 0],
        };
      case "mar-apr":
        return {
          startMonth: "MAY",
          startMonthMinus1: "APR",
          startMonthMinus2: "MAR",
          projValues: [1200, 4800, 7800, 7200, 5700, 5700, 5700, 6600, 5700, 4800, 0, 0],
        };
      case "nov-dec":
        return {
          startMonth: "JAN",
          startMonthMinus1: "DEC",
          startMonthMinus2: "NOV",
          projValues: [1200, 5160, 5700, 5400, 5700, 7200, 7200, 7200, 5700, 5160, 0, 0],
        };
      case "feb-mar-apr":
        return {
          startMonth: "MAY",
          startMonthMinus1: "APR",
          startMonthMinus2: "MAR",
          projValues: [5580, 900, 8340, 8400, 5700, 5700, 5700, 8820, 5700, 900, 0, 0],
        };
      case "oct-nov-dec":
        return {
          startMonth: "JAN",
          startMonthMinus1: "DEC",
          startMonthMinus2: "NOV",
          projValues: [5580, 900, 5700, 5700, 5700, 8460, 8520, 8520, 5700, 900, 0, 0],
        };
      default:
        return {
          startMonth: getContractualMonth({ offset: 0 }).monthShort,
          startMonthMinus1: getContractualMonth({ offset: -1 }).monthShort,
          startMonthMinus2: getContractualMonth({ offset: -2 }).monthShort,
          projValues: Array(12).fill(projDefault),
        };
    }
  }
}
